<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="机构账号编码/开发者账号/对接应用授权KEY/对接应用授权加密字符/三方服务器地址/三方应用授权KEY/三方应用授权加密字符 搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>

            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { pageType: 'add' })"
              v-allow="'actAdd'"
            >
              <b-icon-plus></b-icon-plus>
              新增
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="160px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="应用状态">
              <el-checkbox-group v-model="form.listAppStatus">
                <el-checkbox label="Y">有效</el-checkbox>
                <el-checkbox label="N">无效</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构账号编码">
              <el-input
                v-model="form.accountCode"
                placeholder="请输入机构账号编码"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开发者账号">
              <el-input
                v-model="form.appId"
                placeholder="请输入开发者账号"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对接应用授权KEY">
              <el-input
                v-model="form.appkey"
                placeholder="请输入对接应用授权KEY"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对接应用授权加密字符">
              <el-input
                v-model="form.appSecret"
                placeholder="请输入对接应用授权加密字符"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="三方服务器地址">
              <el-input
                v-model="form.tpAppHost"
                placeholder="请输入三方服务器地址"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="三方应用授权KEY">
              <el-input
                v-model="form.tpAppkey"
                placeholder="请输入三方应用授权KEY"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="三方应用授权加密字符" label-width="160px">
              <el-input
                v-model="form.tpAppSecret"
                placeholder="请输入三方应用授权加密字符"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item label="授权到期时间">
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.expiresInStart"
                      type="date"
                      value-format="timestamp"
                      placeholder="请选择时间"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.expiresInEnd"
                      type="date"
                      value-format="timestamp"
                      placeholder="请选择时间"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-form-item label="创建时间">
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginCreateTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择时间"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endCreateTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择时间"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-form-item label="修改时间">
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginModifyTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择时间"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endModifyTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择时间"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          取消查询
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          重置条件
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          数据检索
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = { keyword: '', listAppStatus: ['Y'] }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
